import React from 'react';
import { Route } from "react-router-dom";
import ExtensionList from '../modules/voice/pbx/views/ExtensionList';
import ExtensionForm from '../modules/voice/pbx/views/ExtensionForm';
import QueueList from '../modules/voice/pbx/views/QueueList';
import QueueForm from '../modules/voice/pbx/views/QueueForm';
import CallsHistory from '../modules/voice/calls/views/CallsHistory';
import LiveCallsView from '../modules/voice/calls/views/LiveCallsView';
import CallDetails from '../modules/voice/calls/views/CallDetails';
import CallsReport from '../modules/voice/calls/views/CallsReport';
import LinesList from '../modules/voice/lines/views/LinesList';
import LinesReleased from '../modules/voice/lines/views/LinesReleased';
import LineInbound from '../modules/voice/lines/views/LineInbound';
import RedirectCallsRulesList from '../modules/voice/pbx/views/RedirectCallsRulesList';
import VoiceMainView from '../modules/voice/views/VoiceMainView';
import CallRoutingSettings from '../modules/voice/pbx/views/CallRoutingSettings';
import BlockList from '../modules/voice/pbx/views/BlockList';


function VoiceRoutes() {
  let k = 0;
  return (
    [
      <Route key={k++} path="/voice/pbx/extensions/edit/:selectedId" element={<ExtensionForm />} />,
      <Route key={k++} path="/voice/pbx/extensions/draft/:selectedId" element={<ExtensionForm />} />,
      <Route key={k++} path="/voice/pbx/queues/edit/:selectedId" element={<QueueForm />} />,

      <Route key={k++} path="/voice/pbx/redirectrules" element={<RedirectCallsRulesList />} />,

      <Route key={k++} path="/voice/call/:selectedId" element={<CallDetails />} />,
      <Route key={k++} path="/voice/report/calls" element={<CallsReport />} />,

      <Route key={k++} path="/voice/lines/inbound/:selectedId" element={<LineInbound />} />,

      <Route key={k++} path="/voice" element={<VoiceMainView />}>
        <Route path="calls/live" element={<LiveCallsView />} />
        <Route path="calls/history" element={<CallsHistory />} />
        <Route path="pbx/extensions" element={<ExtensionList />} />
        <Route path="pbx/queues" element={<QueueList />} />
        <Route path="pbx/blocklist" element={<BlockList />} />
        <Route path="lines" element={<LinesList />} />
        <Route path="released" element={<LinesReleased />} />
        <Route path="pbx/call-routing" element={<CallRoutingSettings />} />
      </Route>,
    ]
  );
}

export default VoiceRoutes;
